import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { DeleteWarningModal } from '@User/MyAccountPage/components'
import pageStyles from '@User/MyAccountPage/styles.css'

import { useDeleteAccountUserProfileMutation } from '~/gql/graphql'
import Box from '~/core/Box'
import Button from '~/core/Button'
import { IdentityType } from '~/redux-modules/identity/type'
import { handleDeleteAccount } from '../logic'
import {
    DELETE_WARNING_MODAL_TITLE,
    DELETE_WARNING_MODAL_BUTTON_TEXT,
} from '../constants'

type DeleteAccountButtonPropsType = {
    className?: string
    identity: IdentityType
}

export default function DeleteAccountButton(
    props: DeleteAccountButtonPropsType,
) {
    const { className, identity } = props
    const [warningModal, setWarningModal] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)
    const dispatch = useDispatch()
    const [deleteAccount] = useDeleteAccountUserProfileMutation()

    return (
        <Box className={className} margin="16px 0" alignItems="center">
            {warningModal && (
                <DeleteWarningModal
                    visible={warningModal}
                    title={DELETE_WARNING_MODAL_TITLE}
                    text={DELETE_WARNING_MODAL_BUTTON_TEXT}
                    onClose={() => setWarningModal(false)}
                    loading={loading}
                    onConfirm={() =>
                        handleDeleteAccount({
                            identity,
                            setLoading,
                            onCancel: () => setWarningModal(false),
                            deleteAccount,
                            dispatch,
                        })
                    }
                />
            )}
            <Box className={pageStyles.mobileLabel}>
                <Button
                    className={pageStyles.mobileLargeWidth}
                    type="danger"
                    name="delete-account"
                    placement="user-profile-personal-information"
                    data-test-target="user-profile-delete-account"
                    onClick={() => setWarningModal(true)}
                    loading={loading}
                    disabled={loading}
                >
                    Delete this account
                </Button>
            </Box>
            <Box className={pageStyles.mobileMargin} color="blackAlpha45">
                All information and data stored will be deleted
            </Box>
        </Box>
    )
}
